<script lang="ts" module>
	import { type VariantProps, tv, cn } from 'tailwind-variants'

	export const alertVariants = tv({
		base: "grid gap-0.5 rounded-lg border px-2.5 py-2 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-4 group/alert relative w-full",
		variants: {
			variant: {
				default: 'text-card-foreground bg-card',
				warning:
					'text-orange-400 bg-card border-orange-400 *:data-[slot=alert-description]:text-orange-400/90 *:[svg]:text-orange-400',
				destructive:
					'text-destructive bg-card *:data-[slot=alert-description]:text-destructive/90 *:[svg]:text-current',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	})

	export type AlertVariant = VariantProps<typeof alertVariants>['variant']
</script>

<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'

	let {
		ref = $bindable(null),
		class: className,
		variant = 'default',
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
		variant?: AlertVariant
	} = $props()
</script>

<div
	bind:this={ref}
	class={cn(alertVariants({ variant }), className)}
	data-slot="alert"
	role="alert"
	{...restProps}
>
	{@render children?.()}
</div>
